(function () {
    'use strict';
    /**
     * @memberof appback
     *@ngdoc service
     *@name ConversacionesService
     *@description
     *Bandeja de entrada global (todas las conversaciones, separadas por contacto)
     */

    angular
        .module('appback')
        .factory('ConversacionesService', ConversacionesService);

    ConversacionesService.$inject = ["$http", "$q"];

    function ConversacionesService($http, $q) {

        var service = {
            GetContactos: GetContactos,
            GetHilo: GetHilo,
            BuscarContactos: BuscarContactos,
            CrearContacto: CrearContacto,
            GetEtiquetas: GetEtiquetas,
            CrearEtiqueta: CrearEtiqueta,
            GetBlacklist: GetBlacklist,
            AgregarBlacklist: AgregarBlacklist,
            QuitarBlacklist: QuitarBlacklist,
            BuscarDistribuidores: BuscarDistribuidores,
        };

        function GetContactos() {
            return $http.get('/backend/conversaciones/getcontactos').then(function (response) {
                if (!response.data || !response.data.success) {
                    return $q.reject(response.data);
                }

                return response.data.data;
            });
        }

        // Por contacto o, si la conversación aún no tiene contacto, por la
        // dirección (email, teléfono...) de la otra parte.
        function GetHilo(contactoId, direccion) {
            return $http.get('/backend/conversaciones/gethilo', {
                params: contactoId ? { id: contactoId } : { direccion: direccion }
            }).then(function (response) {
                if (!response.data || !response.data.success) {
                    return $q.reject(response.data);
                }

                return response.data.data;
            });
        }

        // Reusa el mismo endpoint que el popup "Asignar contacto" del dashboard
        // (backend\controllers\DashboardController::actionSearchContacts()),
        // ya que la búsqueda por nombre/empresa/email/teléfono no depende de
        // ninguna conversación puntual.
        function BuscarContactos(query) {
            return $http.get('/backend/dashboard/search-contacts', {
                params: {
                    q: query
                }
            }).then(function (response) {
                if (!response.data || !response.data.success) {
                    return $q.reject(response.data);
                }

                return response.data.data;
            });
        }

        // Crea un contacto con datos y le enlaza los mensajes sin contacto de
        // direccion (ConversacionesController::actionCrearcontacto()).
        function CrearContacto(direccion, datos) {
            return $http.post('/backend/conversaciones/crearcontacto', jQuery.param(angular.extend({ direccion: direccion }, datos)), {
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
            }).then(function (response) {
                if (!response.data || !response.data.success) {
                    return $q.reject(response.data);
                }

                return response.data.data;
            }, function (response) {
                return $q.reject(response.data);
            });
        }

        // Todas las categorías (ConversationLabel), también las que aún no
        // tiene ninguna conversación (ConversacionesController::actionGetetiquetas()).
        function GetEtiquetas() {
            return $http.get('/backend/conversaciones/getetiquetas').then(function (response) {
                if (!response.data || !response.data.success) {
                    return $q.reject(response.data);
                }

                return response.data.data;
            });
        }

        // datos: { nombre, color, descripcion } (ConversacionesController::actionCrearetiqueta()).
        function CrearEtiqueta(datos) {
            return $http.post('/backend/conversaciones/crearetiqueta', jQuery.param(datos), {
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
            }).then(function (response) {
                if (!response.data || !response.data.success) {
                    return $q.reject(response.data);
                }

                return response.data.data;
            }, function (response) {
                return $q.reject(response.data);
            });
        }

        function datosDe(response) {
            if (!response.data || !response.data.success) {
                return $q.reject(response.data);
            }

            return response.data.data;
        }

        function postForm(url, datos) {
            return $http.post(url, jQuery.param(datos), {
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
            }).then(datosDe, function (response) {
                return $q.reject(response.data);
            });
        }

        // Lista negra de remitentes (EmailBlacklist): las tres llamadas
        // devuelven la lista completa ya actualizada.
        function GetBlacklist() {
            return $http.get('/backend/conversaciones/getblacklist').then(datosDe);
        }

        // datos: { tipo: 'dominio'|'contacto'|'distribuidor', domain, contacto_id, distribuidor_id }
        function AgregarBlacklist(datos) {
            return postForm('/backend/conversaciones/agregarblacklist', datos);
        }

        function QuitarBlacklist(id) {
            return postForm('/backend/conversaciones/quitarblacklist', { id: id });
        }

        function BuscarDistribuidores(query) {
            return $http.get('/backend/conversaciones/buscardistribuidores', {
                params: { q: query }
            }).then(datosDe);
        }

        return service;
    }
})();
